import Vue from 'vue'
import App from './App.vue'
import store from './store'
import jzWeixin from '@jz/weixin'
import '@/plugins/vant'
import '@/plugins/touch-events'
import '@/plugins/arms'
import '@/plugins/frame-animation'
import '@/plugins/clipboard'
import '@/assets/less/reset.less'
import '@/assets/less/base.less'
import 'swiper/css/swiper.css'

/**
 * 微信分享配置
 * @see http://jnpm.jzyx.com/-/web/detail/@jz/weixin
 */
jzWeixin({
  debug: process.env.NODE_ENV === 'development',
  title: process.env.VUE_APP_TITLE_SHARE,
  desc: process.env.VUE_APP_DESCRIPTION,
  imgUrl: process.env.VUE_APP_IMAGE
})

Vue.config.productionTip = false

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
